import { ClientUserPermission } from '~bank-client-users/types'

export interface PermissionsProps {
  id: string
  value: ClientUserPermission[]
}
